if (!customElements.get('custom-product-card')) {
class CustomProductCard extends HTMLElement {
  constructor() {
    super();
    this.productCard = this.closest(".product-card");
    this.select = this.querySelector("[data-card-product-select]");
    this.subsInput = this.querySelector(".card--subscribe-input-wrapper.for-sub");
    this.firmhouseIdInput = this.querySelector("[name='properties[_firmhouseid]']");
    this.intervalUnitOfMeasureInput = this.querySelector("[name='properties[_intervalUnitOfMeasure]']");
    this.plansCheckbox = this.querySelectorAll(".plans-change");
    this.variantsCheckbox = this.querySelectorAll(".radio-check");
    this.oneTimeInputWrapper = this.querySelector(".card--subscribe-input-wrapper.one-time");

   if(this.productCard.querySelector("[data-product-card-json]") != null){
          this.productCardJson = JSON.parse(this.productCard.querySelector("[data-product-card-json]").innerHTML);
        }

        if (this.productCardJson && this.productCardJson.variants) {
            this.variants = this.productCardJson.variants;
        } 

        //this.variants = this.productCardJson.variants;

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    [...this.plansCheckbox, ...this.variantsCheckbox].forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange);
    });

    this.updateFirmhouseValues = this.updateFirmhouseValues.bind(this);

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.select?.addEventListener("change", this.handleSelectChange);
  }

  handleCheckboxChange(event) {
    
    const checkbox = event.target;
    const checkedVariants = this.querySelectorAll(".radio-check:checked");
    const selectedOption = this.select?.options[this.select?.selectedIndex];
    if (checkbox?.classList?.contains("plans-change") && checkedVariants?.length === 0) {

      this.querySelector(".product-card_updated-price").textContent = checkbox.dataset.price;

      if (!checkbox.classList.contains("one-time")) {
        const firmhouseId = selectedOption.dataset.firmhouseid;
        this.updateFirmhouseValues(firmhouseId, "months");
      } else {
        const firmhouseId = this.oneTimeInputWrapper.dataset.firmhouseid;
        this.updateFirmhouseValues(firmhouseId, "default");
      }
      
    }
    
    else {
     
      const checkedRadio = this.querySelector(".radio-check:checked");
      const instockMessage = this.querySelector(".instock-message");
      const soldOutMessage = this.querySelector(".sold-out-message");
      const submitButton = this.querySelector(".quick-add__submit");
      let plansChange = this.querySelector(".plans-change:checked");
      const isOneTime =
        plansChange?.classList.contains("one-time") || this.querySelectorAll(".plans-change:checked").length === 0;
      const discountedProduct = this.productCard.classList.contains("discounted-product");
      const productCardUpdatedPrice = this.querySelector(".product-card_updated-price");

     if (checkedRadio?.dataset.avail === "true") {
        instockMessage.classList.remove("hidden");
        soldOutMessage.classList.add("hidden");
        submitButton.setAttribute("aria-disabled", false);
        const priceType = isOneTime ? 'price' : 'subprice';
        const discountType = discountedProduct ? `${priceType}discountmeta` : priceType;

        productCardUpdatedPrice.textContent = checkedRadio?.dataset?.[discountType];

      } else {
         
        instockMessage.classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
        submitButton.setAttribute("aria-disabled", true);
        const priceType = isOneTime ? "price" : "subprice";
        const discountType = discountedProduct ? `${priceType}discountmeta` : priceType;

        productCardUpdatedPrice.textContent = checkedRadio?.dataset?.[discountType];

      }

      // Set respective Firmhouse Ids
      let firmhouseids = JSON.parse(checkedRadio?.dataset?.firmhouseids);
      if (firmhouseids) {
        console.log('firmhouseids');
        console.log(firmhouseids);
        const variant = this.variants.find(v => v.firmhouseId === parseInt(checkedRadio?.dataset?.firmhouseid));
        firmhouseids = variant ? variant.firmhouseIds : undefined
        console.log('firmhouseiddddddds');
        console.log(firmhouseids);
        this.querySelector(".card--subscribe-input-wrapper.one-time").dataset.firmhouseid = firmhouseids[0];
        this.querySelector(".card--subscribe-input-wrapper.for-sub").dataset.firmhouseid = selectedOption.dataset.firmhouseid;

        let options = this.querySelectorAll(".card--subscribe-input-wrapper.for-sub option");
        options.forEach((option, index) => {
          let arrval = index + 1;
          option.dataset.firmhouseid = firmhouseids[arrval];
        });

        if (this.querySelector(".plans-change:checked").classList.contains("one-time")) {
          this.updateFirmhouseValues(firmhouseids[0], "default");
        } else {
          this.updateFirmhouseValues(selectedOption.dataset.firmhouseid, "months");
        }

      } else {
        this.updateFirmhouseValues(checkbox.dataset.firmhouseid, "default");
      }
    }
  }

  updateFirmhouseValues(firmhouseId, intervalUnitOfMeasure) {
    if (this.firmhouseIdInput) {
      this.firmhouseIdInput.value = firmhouseId;
    }

    if (this.intervalUnitOfMeasureInput) {
      this.intervalUnitOfMeasureInput.value = intervalUnitOfMeasure;
    }
  }

  handleSelectChange() {
    const selectedValue = this.select.value;
    const selectedOption = this.select.options[this.select.selectedIndex];
    const firmhouseId = selectedOption.dataset.firmhouseid;

    if (this.subsInput) {
      this.subsInput.dataset.firmhouseid = firmhouseId;
    }

    this.updateFirmhouseValues(firmhouseId, "months");
  }

  connectedCallback() {
      if(!checkHasPseudoClassSupport()){
        this.addEventListener('mouseenter', () => this.closest('.swiper').style.overflow = 'visible');
        this.addEventListener('mouseleave', () => this.closest('.swiper').style.overflow = 'hidden');
    }
  }
}
 // Make sure to define the custom element
    customElements.define('custom-product-card', CustomProductCard);
};  
function checkHasPseudoClassSupport() {
  return CSS.supports('selector(:has(*))');
} 

